import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6 18L18 6M6 6l12 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>);